module.exports = __webpack_public_path__ + "img/logo_uruguai_udelar_comision_70px.ea05abd3.png";